module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('Form', [_c('Row', [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHENQINGZHUTI')
    }
  }, [_vm._v(_vm._s(_vm.item.topic))])], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('XUEFEN')
    }
  }, [_vm._v(_vm._s(_vm.item.credit))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('KESHI')
    }
  }, [_vm._v(_vm._s(_vm.item.hour))])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('JIFEN')
    }
  }, [_vm._v(_vm._s(_vm.item.integral))])], 1)], 1), _vm._v(" "), (_vm.item.fileName) ? _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('FUJIAN')
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handleDownload(_vm.item)
      }
    }
  }, [_vm._v(_vm._s(_vm.l('XIAZAI')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.l('SHENQINGSHUOMING')
    }
  }, [_vm._v(_vm._s(_vm.item.description))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-526f6252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/views/hourCreditIntegralAudit.vue
// module id = 927
// module chunks = 80